/* eslint-disable @typescript-eslint/camelcase */
import {
    NullableUserInfo,
    State,
    UserInfo,
    Property,
    SubscribeEvent,
    LogType,
    LogMsg,
    StatisticsCounter,
} from "@/models"
import {
    SOCKET_ONOPEN,
    SOCKET_ONCLOSE,
    SOCKET_RECONNECT,
    SOCKET_ONERROR,
    SOCKET_ONMESSAGE,
    SOCKET_RECONNECT_ERROR,
    SOCKET_SUBSCRIBED,
    SOCKET_UNSUBSCRIBED,
    UPDATE_FORM_USER_NAME,
    UPDATE_FORM_USER_PASS,
    UPDATE_FORM_CHECK,
    SOCKET_DISPATCHER_CONNECTED,
    SOCKET_DISPATCHER_DISCONNECTED,
    SOCKET_DISPATCHER_RECONNECTING,
    SOCKET_ON_LOGGING,
    UPDATE_STATISTICS,
    UPDATE_IS_RESTARTING,
} from "@/store/types/mutations"
import { MutationTree } from "vuex"
import { UAcsLoginModuleNamespace } from "@/consts"
import { isFunction } from "lodash"
import { isValidUserId } from "@/utils/validate"
import { notifyInfo, notifyError, notifyWarn } from "@/utils/notify"

const mutations: MutationTree<State> = {
    [SOCKET_ONOPEN](state: State, event: any) {
        state.socket.isConnected = true
        state.socket.$socket = event.currentTarget

        const userInfo = (state as any)[UAcsLoginModuleNamespace]
            .user_info as UserInfo

        if (!isValidUserId(userInfo.id)) {
            state.socket.isSubscribed = false
            return
        }

        const subscribeEvent: SubscribeEvent = {
            type: "subscribe",
            userId: userInfo.id,
        }

        if (isFunction(state.socket.$socket.sendObj)) {
            state.socket.$socket.sendObj(subscribeEvent)
        }
    },
    [SOCKET_ONCLOSE](state: State) {
        state.socket.isConnected = false
        state.socket.isDispatcherConnected = false
        state.socket.$socket = null
    },
    [SOCKET_RECONNECT](state: State) {
        notifyInfo("Websocket", "Reconnecting...")
    },
    [SOCKET_ONERROR](state: State, event: any) {
        notifyError("Websocket", "connection error")
    },
    [SOCKET_SUBSCRIBED](state: State) {
        notifyInfo("Websocket", "Subscribed to websocket events")
        state.socket.isSubscribed = true
        state.isRestarting = false
    },
    [SOCKET_UNSUBSCRIBED](state: State) {
        notifyWarn("Websocket", "Unsubscribed to websocket events")
        state.socket.isSubscribed = false
    },
    [SOCKET_RECONNECT_ERROR](state: State) {
        state.socket.reconnectError = true
        notifyWarn("Websocket", "Couldn't reconnect")
    },
    [SOCKET_DISPATCHER_DISCONNECTED](state: State) {
        state.socket.isDispatcherConnected = false
    },
    [SOCKET_DISPATCHER_CONNECTED](state: State) {
        state.socket.isDispatcherConnected = true
    },
    [SOCKET_DISPATCHER_RECONNECTING](state: State) {
        notifyInfo("Websocket", "Reconnecting to dispatcher...")
    },
    [SOCKET_ON_LOGGING](state: State, payload: LogMsg) {
        if (payload.ty == "info") {
            notifyInfo(payload.scope, payload.message)
        }

        if (payload.ty == "error") {
            notifyError(payload.scope, payload.message)
        }
    },
    [SOCKET_ONMESSAGE](state: State, payload: any) {
        // do nothing for now
    },
    [UPDATE_FORM_USER_NAME](state: State, paylod: string) {
        const form = (state as any)[UAcsLoginModuleNamespace].form as any

        form.username = paylod
    },
    [UPDATE_FORM_USER_PASS](state: State, payload: string) {
        const form = (state as any)[UAcsLoginModuleNamespace].form as any

        form.password = payload
    },
    [UPDATE_FORM_CHECK](state: State, payload: boolean) {
        const form = (state as any)[UAcsLoginModuleNamespace].form as any

        form.is_checked = payload
    },
    [UPDATE_STATISTICS](state: State, payload: StatisticsCounter) {
        state.statistics_counter = payload
    },
    [UPDATE_IS_RESTARTING](state: State, payload: boolean) {
        state.isRestarting = payload
    },
}

export default mutations
